/** @format */

import {
  SET_ADVANCED_QUESTIONS,
  SET_BASIC_QUESTIONS,
  SET_INTERMEDIATE_QUESTIONS,
} from "../action/interviewQuestions";

export default function InterviewQuestionsReducer(
  state = { advancedQuestions: [], intermediateQuestions: [], basicQuestions: [] },
  action
) {
  switch (action.type) {
    case SET_ADVANCED_QUESTIONS:
      state.advancedQuestions = action.payload;
      return { ...state };
    case SET_INTERMEDIATE_QUESTIONS:
      state.intermediateQuestions = action.payload;
      return { ...state };
    case SET_BASIC_QUESTIONS:
      state.basicQuestions = action.payload;
      return { ...state };
    default:
      return state;
  }
}
